module.exports = __webpack_public_path__ + "img/spike-protein-alpha.1c800da9.png";